import { z } from 'zod';
// Two pagination envelopes (per CONVENTIONS §Pagination): OFFSET for bounded,
// random-access lists; CURSOR (keyset) for unbounded, continuously-inserted,
// DESC-sorted feeds with "load older" UX. The audit page is the first cursor
// consumer; the cursor envelope is reusable by any feed (notifications, alarms).
// Server caps `limit` at 100.
export const PaginationSchema = z
    .object({
    limit: z.coerce.number().int().positive().max(100).default(25),
    offset: z.coerce.number().int().nonnegative().default(0),
})
    .strict();
// Cursor (keyset) request params. `cursor` is OPAQUE — clients must not parse or
// construct it; they echo back the `nextCursor` the server returned. Absent
// cursor = first (newest) page.
export const CursorPaginationSchema = z
    .object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().positive().max(100).default(25),
})
    .strict();
// Cursor response envelope. `nextCursor` is null when no older page remains.
export function cursorResponseSchema(item) {
    return z
        .object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
        limit: z.number().int().positive(),
    })
        .strict();
}
export const SortSchema = z
    .object({
    sort_by: z.string().min(1).optional(),
    sort_dir: z.enum(['asc', 'desc']).default('asc'),
})
    .strict();
/** A count over an UNBOUNDED population — history: the filed tickets — is
 *  capped here (ADR-078 §2): the server counts at most `cap + 1` rows and
 *  answers up to that; a total past the cap reads "1,000+" on the screen and
 *  the pager offers next and previous only. Both sides read this one constant. */
export const HISTORY_COUNT_CAP = 1000;
/** A list's COUNT alone, on the same predicates as its rows (ADR-078 §6): the
 *  phone's filter drawer asks it before it shows the rows ("Show results (n)"
 *  — ADR-080 §13). Each list's `/count` sibling takes the list's own querystring
 *  schema and answers this; the list-read kit absorbs them when it lands. */
/** The count-only face's answer (ADR-078 §6): `total` — and `capped` when that total is a FLOOR (a capped history
 *  inside it, ADR-078 §2: the number holds `cap + 1`, the screen prints "n+"). A list with no history leaves it out. */
export const CountResponseSchema = z.object({ total: z.number().int().nonnegative(), capped: z.boolean().optional() }).strict();
export function paginatedResponseSchema(item) {
    return z
        .object({
        items: z.array(item),
        total: z.number().int().nonnegative(),
        limit: z.number().int().positive(),
        offset: z.number().int().nonnegative(),
    })
        .strict();
}
